import * as actionType from "../constants/planManager";

const initialState = {
  PlanManagerStart: false,
  PlanManagerSuccess: false,
  PlanManagerFailed: false,
  PlanManagerError: "",
  PlanManagerData: {},
  PlanManagerEnd: false,
  updating: false,
  updateSuccess: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.PlanManager_START:
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        showLoader: true,
      };
    case actionType.PlanManager_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        showLoader: false,
        PlanManagerSuccess: true,
        planManagerData: action.planManagerData,
      };

    case actionType.PlanManager_FAIL:
      return {
        ...state,
        ...action.payload,
        showLoader: false,
        isAuthenticated: true,
        PlanManagerSuccess: false,
      };
    case actionType.PlanManager_ERROR:
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        PlanManagerSuccess: false,
        showLoader: false,
        IsError: true,
      };
    case actionType.PlanManager_END:
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        PlanManagerSuccess: false,
        showLoader: false,
      };

    case actionType.PlanManager_UPDATE_START:
      return { ...state, updating: true, updateSuccess: false };
    case actionType.PlanManager_UPDATE_SUCCESS:
      return { ...state, updating: false, updateSuccess: true };
    case actionType.PlanManager_UPDATE_FAIL:
      return { ...state, updating: false, updateSuccess: false };

    case actionType.PlanManager_ACTION_START:
      return { ...state, actionInProgress: true };
    case actionType.PlanManager_ACTION_SUCCESS:
      return { ...state, actionInProgress: false };
    case actionType.PlanManager_ACTION_FAIL:
      return { ...state, actionInProgress: false };

    default:
      return state;
  }
};
